
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"7.5","cy":"7.5","r":"7.5","fill":"#413D3D"}}),_c('path',{attrs:{"d":"M9.75 5.25l-4.5 4.5M5.25 5.25l4.5 4.5","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    